import {Component,OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-major-frameworks',
  templateUrl: './major-frameworks.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./major-frameworks.component.scss'],
 })

export class MajorFrameworksComponent implements OnInit {

  sectionCards: { frameWorkName: string,    }[] = [
    {
      frameWorkName:'NCA',
    },
    {
      frameWorkName:'SAMA',
    },
    {
      frameWorkName:'DGA',
    },
    {
      frameWorkName:'NDMO',
    },
    {
      frameWorkName:'ISO',
    },
    {
      frameWorkName:'NIST',
    },
    {
      frameWorkName:'PCI DSS',
    },
    {
      frameWorkName:'ARAMCO',
    },
    {
      frameWorkName:'COSO',
    },
    {
      frameWorkName:'SOX',
    },
    {
      frameWorkName:'GDPR',
    },
    {
      frameWorkName:'SOC2',
    },
    {
      frameWorkName:'CST',
    },
    {
      frameWorkName:'CMA',
    },
    {
      frameWorkName:'COBIT',
    },
    {
      frameWorkName:'CUSTOM',
    },

  ]

  constructor() { }


  ngOnInit(): void {

  }

}



